import { AtlasGqlInspectionStatus } from 'types/atlas-graphql';

// Statuses where data capture is complete and the inspection is ready/in-flight for delivery.
// RELEASED is kept for backwards compatibility with older inspections.
export const RELEASED_EQUIVALENT_STATUSES = new Set([
  AtlasGqlInspectionStatus.Released,
  AtlasGqlInspectionStatus.AnalysisPending,
  AtlasGqlInspectionStatus.AnalysisInProgress,
  AtlasGqlInspectionStatus.Delivered,
  AtlasGqlInspectionStatus.AnalysisComplete,
]);

export const isReleasedEquivalent = (status?: AtlasGqlInspectionStatus | string | null): boolean =>
  !!status && RELEASED_EQUIVALENT_STATUSES.has(status as AtlasGqlInspectionStatus);

// Without the enhanced_inspection_statuses toggle, any non-DRAFT inspection is displayed
// and treated as RELEASED.
export const getDisplayStatus = (
  status: AtlasGqlInspectionStatus | string | null | undefined,
  hasEnhancedStatuses: boolean
): AtlasGqlInspectionStatus | string | null | undefined => {
  if (!hasEnhancedStatuses && status && status !== AtlasGqlInspectionStatus.Draft) {
    return AtlasGqlInspectionStatus.Released;
  }
  return status;
};
